import React, { useState, useEffect } from 'react'
import PhotoViewer from './PhotoViewer'
function PhotoAlbums() {
    const [albums, setAlbums] = useState([]);
    const [currAlbum, setCurrAlbum] = useState(0);
    useEffect(
        () => {

            var url = "/Photo/GetPhotoAlbums"; // process.env.REACT_APP_APIURL + "GetPhotoAlbums";
            console.log(url);
            fetch(url).then(res => res.json()).then((data) => {
                console.log(data);
                setAlbums(data);
                console.log(data);
            }).catch(err => alert(err));
        }, []);

    useEffect(
        () => {
            console.log("new Album Logic will go here");

        }, [currAlbum]);

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-4">
                    <span>Pick an album below:</span><br/>
                    <select onChange={(e) => { setCurrAlbum(e.target.value); }}>
                        <option key={0} value={0}>Choose a Photo Album</option>

                        {albums.map((option) => (
                            <option key={option.photoAlbumId} value={option.photoAlbumId}>{option.albumName}</option>
                        ))}
                    </select>
                </div>
                
                <div className="col-lg-8">
                    {(albums.length > 0 && currAlbum >= 0 && albums[currAlbum-1]!==undefined   ) && albums[currAlbum-1].albumDescription }
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12"></div>&nbsp;
                </div>
            <div className="row">
                <div className="col-lg-12">
                    {currAlbum > 0 && <PhotoViewer albumId={currAlbum}  ></PhotoViewer>}

                </div>
            </div>

        </div>)




}
export default PhotoAlbums